module.exports = __webpack_public_path__ + "img/10-choose-file.1924e54f.png";